import type { EventStatusEnum } from "../../apiClient/generated";

interface EventStatusV2DisplayProps {
    eventStatus: EventStatusEnum;
    hideText?: boolean;
}

export const EventStatusV2Display = (props: EventStatusV2DisplayProps) => {
    let color = "black";
    let statusString = "";

    if (props.eventStatus === "COMPLETED" || props.eventStatus === "ARCHIVED") {
        color = "green-500";
        statusString = "Completed";
    } else if (props.eventStatus === "REJECTED") {
        statusString = "Rejected";
        color = "gray-500";
    } else if (props.eventStatus === "CREATED" || props.eventStatus === "NEW") {
        statusString = "New";
        color = "red-500";
    } else if (props.eventStatus === "WAITING_APPROVAL") {
        statusString = "Waiting Approval";
        color = "yellow-500";
    } else {
        statusString = "Work in progress";
        color = "yellow-500";
    }

    return (
        <div
            title={statusString}
            className="w-fit h-fit p-1 flex justify-center items-center capitalize"
        >
            {props.hideText ? "" : statusString}
            <div
                className={`ml-1 h-2.5 w-2.5 bg-${color} rounded-full shadow shadow-${color}`}
            />
        </div>
    );
};
